import Resource from "./resource";

export class MaintenanceConfigurationResource extends Resource {
    IsInMaintenanceMode: boolean;
}

export default MaintenanceConfigurationResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/maintenanceConfigurationResource.ts